module.exports = __webpack_public_path__ + "c1dab414.svg";